export default __webpack_public_path__ + "static/LIMA_logo_staand_zwart-6957e73bdf0f207e9452b3f9bcf4da75.png";